export default __webpack_public_path__ + "static/media/MAX 125_3.01798300.webp";